module.exports = __webpack_public_path__ + "static/media/25-5.b5d7b455.mp3";